<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 44 19"
    :aria-labelledby="iconName"
    role="presentation"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.28105 4.15466C7.09316 4.22316 7.90528 3.74362 8.41285 3.13562C8.91197 2.5105 9.24189 1.6713 9.15729 0.814972C8.43823 0.849225 7.54998 1.29452 7.04241 1.91964C6.57713 2.45912 6.17953 3.33258 6.28105 4.15466ZM15.9424 15.1841V1.83399H20.8912C23.446 1.83399 25.231 3.61515 25.231 6.21839C25.231 8.82163 23.4122 10.6199 20.8235 10.6199H17.9896V15.1841H15.9424ZM9.14916 4.31737C8.4337 4.27568 7.78087 4.53517 7.25357 4.74477C6.91423 4.87965 6.62688 4.99387 6.40827 4.99387C6.16294 4.99387 5.86372 4.87354 5.52777 4.73844C5.08756 4.56142 4.58428 4.35903 4.05651 4.36875C2.84679 4.38587 1.72167 5.0795 1.10413 6.18416C-0.164807 8.39349 0.774203 11.6647 2.00084 13.463C2.60147 14.3535 3.32053 15.3298 4.268 15.2955C4.68483 15.2796 4.98467 15.1508 5.29498 15.0175C5.65223 14.864 6.02335 14.7046 6.60283 14.7046C7.16223 14.7046 7.51712 14.8599 7.85779 15.0089C8.18172 15.1506 8.49279 15.2867 8.95459 15.2784C9.9359 15.2612 10.5534 14.3878 11.1541 13.4972C11.8022 12.5414 12.0871 11.6086 12.1303 11.467L12.1303 11.467L12.1354 11.4506C12.1343 11.4495 12.1263 11.4458 12.1122 11.4393C11.8955 11.3389 10.2394 10.5714 10.2235 8.51338C10.2076 6.78597 11.5371 5.91076 11.7464 5.77298C11.7592 5.7646 11.7677 5.75894 11.7716 5.756C10.9257 4.48863 9.60598 4.35162 9.14916 4.31737ZM28.9715 15.2869C30.2574 15.2869 31.4502 14.6275 31.9916 13.5828H32.0339V15.1841H33.9288V8.53904C33.9288 6.6123 32.4061 5.37062 30.0628 5.37062C27.8887 5.37062 26.2814 6.62943 26.2222 8.35921H28.0664C28.2186 7.53713 28.9715 6.99765 30.0036 6.99765C31.2556 6.99765 31.9578 7.58851 31.9578 8.67605V9.41249L29.403 9.56663C27.0258 9.71221 25.74 10.697 25.74 12.4096C25.74 14.1394 27.0681 15.2869 28.9715 15.2869ZM29.5195 13.7027C28.4282 13.7027 27.7345 13.1717 27.7345 12.3582C27.7345 11.519 28.4029 11.0309 29.6802 10.9538L31.9559 10.8083V11.5618C31.9559 12.8121 30.9069 13.7027 29.5195 13.7027ZM40.2116 15.7065C39.391 18.0443 38.452 18.815 36.4555 18.815C36.3032 18.815 35.7957 18.7978 35.6772 18.7636V17.1623C35.8041 17.1794 36.1171 17.1965 36.2779 17.1965C37.183 17.1965 37.6906 16.8112 38.0036 15.8093L38.1897 15.2184L34.7213 5.49906H36.8616L39.2725 13.3858H39.3148L41.7258 5.49906H43.8069L40.2116 15.7065ZM17.988 3.58095H20.3482C22.1248 3.58095 23.1399 4.54004 23.1399 6.22701C23.1399 7.91397 22.1248 8.88162 20.3398 8.88162H17.988V3.58095Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon",
    },
    width: {
      type: [Number, String],
      default: 44,
    },
    height: {
      type: [Number, String],
      default: 19,
    },
    color: {
      type: String,
      default: "#AAAAAA",
    },
  },
};
</script>
